import { InitComponentStateType, createPersistentComponentState } from '@/state';

import { SortDirectionEnum } from '@/models/gen/graphql';
import { customIndexedDBStorage } from '@/state/storage';

export enum LocationSortColumnEnum {
  name = 'name',
  cityName = 'cityName',
  stateCode = 'stateCode',
  zipCode = 'zipCode',
  phoneNumber = 'phoneNumber',
}

export type LocationsTableState = {
  sorting: {
    column: LocationSortColumnEnum | undefined;
    direction: SortDirectionEnum | undefined;
  };
  onSort: (column: LocationSortColumnEnum) => void;
};

const initLocationsTableState: InitComponentStateType<LocationsTableState> = (set): LocationsTableState => ({
  sorting: { column: undefined, direction: undefined },
  onSort: (column: LocationSortColumnEnum): void => {
    set((current: LocationsTableState): LocationsTableState => {
      const isSameColumn = current.sorting.column === column;
      let direction: SortDirectionEnum | undefined;
      if (!isSameColumn) direction = SortDirectionEnum.Asc;
      else if (current.sorting.direction === SortDirectionEnum.Asc) direction = SortDirectionEnum.Desc;
      else direction = undefined;
      return { ...current, sorting: { column: direction ? column : undefined, direction } };
    });
  },
});

const useLocationsTableState = createPersistentComponentState('LocationsState', initLocationsTableState, {
  storage: customIndexedDBStorage,
});

export default useLocationsTableState;
